import React, { useState } from "react";
import TextBox from "./TextBox";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { StyleSheet, Text, View } from "react-native";
import { IS_WEB } from "@services/Config";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import MaskInput from "react-native-mask-input";
import IconMaterial from "./IconMaterial";

export default function CaixaTextoInputIcone({
  iconName,
  keyboardType,
  dataDetectorTypes,
  placeholderInput,
  onChangeTextInput,
  isSenha = false,
  maxLength,
  value,
  maskInput,
  textContentType = 'none',
  styleBox,
  isValid = true,
  invalidMessage = "Digite um email ou número de telefone",
  autoComplete = 'off',
  autoCapitalize,
  iconAction = null,
  autoCompleteOverride,
}) {
  const [focus, setFocus] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const inputfocus = StyleSheet.create({
    input: {
      borderColor: !isValid ? Colors.ALERT : focus ? Colors.PRIMARY : Colors.BLACK,
      borderWidth: focus ? 2 : 1,
    }
  })
  switch (textContentType) {
    case ('emailAddress'):
      autoComplete = 'email'
      break
    case ('newPassword'):
      autoComplete = 'password-new'
      break
    case ('name'):
      autoComplete = 'name'
      break
    case ('telephoneNumber'):
      autoComplete = 'tel-device'
      break
    case ('telephoneNumber'):
      autoComplete = 'name'
      break
    case ('username'):
      autoComplete = 'username'
      break
    case ('password'):
      autoComplete = 'password'
      break
    case ('creditCardNumber'):
      autoComplete = 'cc-number'
      break
    // default:
    //   autoComplete = 'off'
    //   break;
  }
  if (autoCompleteOverride) {
    autoComplete = autoCompleteOverride;
  }

  const IconAction = () => {
    if (focus) {
      if (iconAction) {
        return iconAction
      }
      else if (isSenha) {
        return <Icon style={styles.iconAction}
          name={showPassword ? "eye-outline" : "eye-off-outline"}
          size={24}
          color={Colors.BLACK}
          onPress={() => setShowPassword(!showPassword)} />
      } else {
        return <IconMaterial style={styles.iconAction}
          name={"clear"}
          size={24}
          color={Colors.BLACK}
          onPress={() => {
            onChangeTextInput("")
          }} />
      }
    }
  }

  const handleFocus = () => {
    if (!IS_WEB) {
      setFocus(true);
    }
  };

  const handleBlur = () => {
    if (!IS_WEB) {
      setFocus(false);
    }
  };

  return (
    <>
      <TextBox style={[{ marginBottom: isValid ? 20 : 5 }, styleBox, inputfocus.input]}>
        {iconName ? <Icon style={styles.icon}
          name={iconName}
          size={24}
          color={Colors.BLACK} /> : null}
        <MaskInput
          style={[styles.textInput, { marginLeft: iconName ? 38 : 16 }]}
          placeholder={placeholderInput}
          placeholderTextColor={Colors.GRAY_DARK}
          onChangeText={onChangeTextInput}
          secureTextEntry={isSenha && !showPassword}
          keyboardType={keyboardType}
          dataDetectorTypes={dataDetectorTypes}
          maxLength={maxLength}
          value={value}
          mask={maskInput}
          autoCapitalize={autoCapitalize ? autoCapitalize : placeholderInput == "Nome" ? "words" : "none"}
          autoComplete={autoComplete}
          textContentType={textContentType}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        <IconAction />
      </TextBox>
      {!isValid ? <View style={styles.viewValidator}>
        <Icon name="alert-circle" color={Colors.ALERT} />
        <Text style={styles.validator}>
          {invalidMessage}
        </Text>
      </View> : null}
    </>
  );
}

const styles = StyleSheet.create({
  icon: {
    position: "absolute",
    left: 10,
  },
  iconAction: {
    position: "absolute",
    right: 5,
  },
  textInput: {
    marginLeft: 38,
    fontSize: Fonts.FONT_SIZE_18,
    width: "75%",
  },
  validator: {
    color: Colors.ALERT,
    marginLeft: 3,
  },
  viewValidator: {
    flexDirection: "row",
    alignItems: "center",
    alignContent: "flex-start",
    marginBottom: 20,
    // width: "70%"
  }
});
